import type { ReactNode, ReactElement } from 'react';
import { isValidElement, Fragment } from 'react';

/** Проверить, можно ли накидывать обработчики событий на переданный элемент */
export const isAllowedElement = <P>(reactNode: ReactNode): reactNode is ReactElement<P> =>
    isValidElement<P>(reactNode) && reactNode.type !== Fragment;
